import InfoIcon from '@mui/icons-material/Info';
import { styled, SxProps } from '@mui/material';
import Badge from '@mui/material/Badge';
import Tooltip from '@mui/material/Tooltip';
import * as React from 'react';

const StyBadge = styled(Badge, {
    name: 'StyBadge',
})({
    verticalAlign: 'inherit',
    maxWidth: '100%', // Do not overflow container
    marginRight: '1.5rem', // keep some space for the badge
    '& .MuiBadge-badge': {
        background: 'none',
        right: '-0.50rem',
        top: '0.30rem',
        zIndex: 'inherit',
    },
});

type Props = {
    tooltip: React.ReactNode;
    children: React.ReactNode;
    sx?: SxProps;
};

/**
 * Display a badge with an info icon and a tooltip.
 */
const TextInfo = ({
    tooltip,
    children,
    sx = undefined,
}: Props): React.ReactElement => (
    <StyBadge
        sx={sx}
        color="secondary"
        badgeContent={
            <Tooltip title={tooltip} key="button-element">
                <InfoIcon color="primary" sx={{ fontSize: 16 }} />
            </Tooltip>
        }
    >
        {children}
    </StyBadge>
);

export default TextInfo;
